import type { MouseEvent } from 'react';
import { Button, Card, CardHeader, CardContent, Stack, Typography, Box, Divider } from '@mui/material';
import Grid from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { fDateTime } from '../../../utils/formatTime';
import Iconify from '../../../components/iconify';
import { Status, PaymentStatus } from '../../../components/request';
import type { BulkRequestProps } from '../../../models/bulkRequest.types';

interface BulkRequestListUserViewItemProps extends BulkRequestProps {
	handleOpenMenu: (event: MouseEvent<HTMLElement>) => void;
	handleOpenRequestDetail: (event: MouseEvent<HTMLElement>) => void;
}

export default function BulkRequestListUserViewItem(props: BulkRequestListUserViewItemProps) {
	const { id, tests, status, location, assessmentDates, paymentStatus, handleOpenMenu, handleOpenRequestDetail } =
		props;

	return (
		<Card variant="outlined" sx={{ width: 280, borderRadius: 2 }}>
			<CardHeader
				action={
					<IconButton data-request-id={id} onClick={handleOpenMenu}>
						<MoreVertIcon />
					</IconButton>
				}
				title={`Bulk Request ${id}`}
			/>
			<CardContent
				sx={{
					pt: 2,
					display: 'flex',
					flexDirection: 'column',
					height: '90%',
				}}
			>
				<Stack spacing={0.5} sx={{ flexGrow: 1 }}>
					<Divider />

					<Box>
						{tests?.map((test) => (
							<Stack key={test.id} direction="row" justifyContent="space-between" alignItems="flex-start">
								<Box>
									<Typography variant="body2" fontWeight={200}>
										{test.quantity} <strong>×</strong> {test.name}
									</Typography>
								</Box>
							</Stack>
						))}
					</Box>

					{assessmentDates && (
						<Grid container>
							<Grid size={1.2}>
								<Iconify icon={'eva:calendar-outline'} />
							</Grid>

							<Grid size={10}>
								<Stack>
									{assessmentDates.length > 0 ? (
										assessmentDates.map((date, i) => {
											return (
												<Typography key={date?.toString()} variant="body2" color="text.secondary">
													{fDateTime(date)}
												</Typography>
											);
										})
									) : (
										<Typography variant="body2">Date Pending</Typography>
									)}
								</Stack>
							</Grid>
						</Grid>
					)}

					{location && (
						<Grid container>
							<Grid size={1.2}>
								<Iconify icon={'eva:pin-outline'} />
							</Grid>

							<Grid size={10}>
								<Stack direction="row" alignItems="flex-start" spacing={1}>
									<Typography variant="body2" color="text.secondary">
										{location}
									</Typography>
								</Stack>
							</Grid>
						</Grid>
					)}
				</Stack>
				<Stack sx={{ mb: 1 }}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							pt: 1,
						}}
					>
						<PaymentStatus paymentStatus={paymentStatus || ''} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							pt: 1,
						}}
					>
						<Status status={status || ''} />
					</Box>

					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							pt: 2,
						}}
					>
						<Button variant="outlined" data-req-id={id} onClick={handleOpenRequestDetail}>
							View Booking Details
						</Button>
					</Box>
				</Stack>
			</CardContent>
		</Card>
	);
}
